module.exports = __webpack_public_path__ + "img/072-bonaire.5a2b17ae.svg";